import React from 'react'
import type { GamingInjuriesProps } from '@/features/enrollment'
import { gamingInjuriesOptions } from '../validation/healthLegalValidation'

export default function GamingInjuries({ enrollmentData, updateEnrollmentData, errors, handleCheckboxChange }: GamingInjuriesProps) {
  const selectedInjuries = (enrollmentData.injuriesAilments || []).filter((injury: string) => injury !== 'No injury')
  const selectionCount = selectedInjuries.length
  
  return (
    <div>
      <label className="block text-sm font-medium text-accent-900 mb-2">
        Have you had any of the following injuries or diagnoses due to video games? <span className="text-red-500">*</span>
        {enrollmentData.injuriesAilments && (enrollmentData.injuriesAilments.includes("Gamer's rage") || enrollmentData.injuriesAilments.includes("Gamer's thumb")) && (
          <span className="ml-2 text-xs text-gray-500">
            (Auto-selected: 50-50 probability)
          </span>
        )}
      </label>
      
      {/* Selection Counter */}
      <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-blue-800">
          <span className="font-medium">Selection Progress:</span>
          <span className={`ml-2 font-semibold ${selectionCount >= 1 && selectionCount <= 5 ? 'text-green-600' : 'text-orange-600'}`}>
            {selectionCount} of 1-5 required
          </span>
        </p>
        <p className="text-xs text-blue-600 mt-1">
          Please select between 1 and 5 injuries (excluding "No injury")
        </p>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {gamingInjuriesOptions.map((injury) => (
          <label key={injury} className={`flex items-center ${injury === 'No injury' ? 'bg-red-50 p-2 rounded border border-red-200' : ''}`}>
            <input 
              type="checkbox" 
              name="injuriesAilments"
              value={injury}
              checked={(enrollmentData.injuriesAilments || []).includes(injury)}
              onChange={(e) => handleCheckboxChange('injuriesAilments', injury, e.target.checked)}
              className="form-checkbox text-primary-600" 
            />
            <span className={`ml-2 ${injury === 'No injury' ? 'text-red-700 font-medium' : 'text-accent-700'}`}>
              {injury}
              {injury === 'No injury' && (
                <span className="ml-2 text-xs text-red-600 font-bold">⚠️ WILL DISQUALIFY</span>
              )}
            </span>
          </label>
        ))}
      </div>
      
      {/* Other Injury Input */}
      {(enrollmentData.injuriesAilments || []).includes('Other injury') && (
        <div className="mt-3">
          <label className="block text-sm font-medium text-accent-900 mb-2">Other Injury:</label>
          <input
            type="text"
            className="input-field w-full"
            placeholder="Specify other injury"
            value={enrollmentData.otherInjury || ''}
            onChange={(e) => updateEnrollmentData('otherInjury', e.target.value)}
          />
        </div>
      )}
      
      {errors.injuriesAilments && (
        <p className="mt-1 text-sm text-red-600">{errors.injuriesAilments}</p>
      )}
    </div>
  )
}
